<script setup>
import { NuxtLink } from '#components'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  to: {
    type: String,
    default: '#',
  },
})
</script>

<template>
  <component
    :is="props.to ? NuxtLink : 'div'"
    class="equal-small-2 tag"
    :to="props.to"
  >
    {{ props.name }}
  </component>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.tag {
  display: inline-flex;
  align-items: center;
  height: 29px;
  padding: 0 15px;
  border-radius: 8px;
  border: 1px solid $color-dark-04;
  background-color: $color-dark-04;
  color: #fff;
  line-height: 29px;

  cursor: pointer;
  text-decoration: none;
  outline: unset;
  transition: 0.3s ease;

  &:hover,
  &:focus,
  &:active {
    background-color: $color-dark-01;
  }

  &--search {
    &:hover,
    &:focus,
    &:active {
      border-color: $color-dark-disabled;
    }
  }
}
</style>
